import { alpha } from '@mui/material';
/**
 * MuiTypography
 */
const MuiTypography = {
  defaultProps: {
    variantMapping: {
      subtitle1: 'p',
      subtitle2: 'p'
    }
  },
  styleOverrides: {
    root: ({
      theme
    }) => ({
      '&.MuiTypography-mention': {
        fontWeight: 400,
        fontSize: theme.typography.pxToRem(14),
        lineHeight: theme.typography.pxToRem(18),
        borderRadius: 8,
        padding: theme.spacing(0.5),
        color: theme.palette.primary.main,
        backgroundColor: theme.palette.primary[200]
      },
      // TODO danielmana heights not matching mentions inside the DraftJS editor
      '&.MuiTypography-squiggly, &.MuiTypography-squigglyInvalid': {
        fontFamily: 'menlo',
        fontWeight: 400,
        fontSize: theme.typography.pxToRem(12),
        lineHeight: 1.5,
        borderRadius: 8,
        padding: theme.spacing(0.5),
        color: theme.palette.tertiary.dark,
        backgroundColor: alpha(theme.palette.tertiary.light, 0.24),
        '&.MuiTypography-squigglyInvalid': {
          color: theme.palette.error.dark,
          backgroundColor: alpha(theme.palette.error.light, 0.24)
        }
      }
    })
  }
};
export default MuiTypography;